<template>
  <div id="toolbarMain">
    <b-row>
      <b-col> <h3>QR Code Manager</h3></b-col>
      <b-col>
        <b-button v-b-modal.toolbarModalNewFile variant="success"
          >Upload PDF</b-button
        >
      </b-col>
    </b-row>
    <b-modal id="toolbarModalNewFile" title="Upload Document">
      <uploader-component
        buttonLabel="Submit"
        @didSubmit="didSubmitData()"
      ></uploader-component>
      <template v-slot:modal-footer="{}"><div></div></template>
    </b-modal>
  </div>
</template>

<script>
import UploaderComponent from "./Uploader.vue";

export default {
  components: { UploaderComponent },
  data() {
    return {
      newFileData: null,
      newFileName: null,
    };
  },
  methods: {
    didSubmitData: function() {
      this.$bvModal.hide("toolbarModalNewFile");
      this.$emit("refresh");
      console.log("REQUESTING DATA REFRESH");
    },
    showUploader: function() {
      document.querySelector("#toolbarNewDocModal").modal("show");
    },
  },
};
</script>

<style>
#toolbarMain {
  background-color: #b6b6b6;
}
</style>
